document.addEventListener('DOMContentLoaded', function() {
  // Find all hero slides
  var slides = document.querySelectorAll('[class*="hero__slide--slide"]');
  
  slides.forEach(function(slide) {
    // Look for the button link inside the slide
    var button = slide.querySelector('a[href]');
    
    if (button && button.href) {
      var targetUrl = button.href;
      slide.style.cursor = 'pointer';
      
      slide.addEventListener('click', function(e) {
        // Don't double-trigger if the user actually clicked the button itself
        if (e.target.closest('a')) return;
        window.location.href = targetUrl;
      });
    }
  });
});



document.addEventListener('DOMContentLoaded', function() {
  initWineCharts();
});
setTimeout(initWineCharts, 500);

function initWineCharts() {
  var charts = document.querySelectorAll('.chart');
  
  charts.forEach(function(chart) {
    var label = chart.querySelector('.chart__label');
    if (!label) return;
    
    var text = label.textContent.trim().toLowerCase();
    
    if (text.includes('dry')) {
      chart.classList.add('chart--dry');
    } else if (text.includes('sweet')) {
      chart.classList.add('chart--sweet');
    } else if (text.includes('temp') || text.includes('room') || text.includes('cool')) {
      chart.classList.add('chart--temperature');
    } else if (text.includes('light') || text.includes('full') || text.includes('body')) {
      chart.classList.add('chart--body');
    } else if (text.includes('smooth') || text.includes('tannic') || text.includes('tannin')) {
      chart.classList.add('chart--tannin');
    }
    
    var graph = chart.querySelector('.chart__graph');
    if (graph && !graph.querySelector('.chart__scale')) {
      var scale = document.createElement('div');
      scale.className = 'chart__scale';
      scale.innerHTML = '<span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>';
      graph.appendChild(scale);
    }
  });
}